import { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import clienteAuthService from '../api/authService';

export default function ClienteRegister() {
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({
    nome: '', cognome: '', email: '', password: '', password_confirmation: '', telefono: '',
    tipo_cliente: 'privato', ragione_sociale: '', codice_fiscale: '', partita_iva: '',
    codice_destinatario: '', pec: '', richiede_fattura: false, codice_amico: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showFiscal, setShowFiscal] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');
    if (ref) {
      setForm(prev => ({ ...prev, codice_amico: ref }));
    }
  }, [location]);

  const submit = async (e) => {
    e.preventDefault();
    if (!acceptTerms) {
      setError('Devi accettare Termini e Privacy per registrarti.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await clienteAuthService.register(form);
      navigate('/area-riservata');
    } catch (err) {
      const errors = err.response?.data?.errors;
      const first = errors ? Object.values(errors).flat()[0] : null;
      setError(first || err.response?.data?.message || 'Errore registrazione');
    } finally {
      setLoading(false);
    }
  };

  const set = (k, v) => setForm((prev) => ({ ...prev, [k]: v }));

  return (
    <div className="min-h-screen bg-[#FFFEFA] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md mang-card p-8">
        <h1 className="text-2xl font-bold mb-6">Crea account</h1>
        {error && <div className="bg-red-50 text-red-700 text-sm p-3 rounded-lg mb-4">{error}</div>}
        <form onSubmit={submit} className="space-y-3">
          {['nome', 'cognome', 'email', 'telefono'].map((f) => (
            <div key={f}>
              <label className="block text-sm capitalize mb-1">{f === 'email' ? 'Email' : f}</label>
              <input type={f === 'email' ? 'email' : 'text'} required={f !== 'telefono'}
                className="w-full border rounded-xl px-4 py-2" value={form[f]}
                onChange={(e) => set(f, e.target.value)} />
            </div>
          ))}
          <div>
            <label className="block text-sm mb-1">Password</label>
            <input type="password" required minLength={8} className="w-full border rounded-xl px-4 py-2"
              value={form.password} onChange={(e) => set('password', e.target.value)} />
          </div>
          <div>
            <label className="block text-sm mb-1">Conferma password</label>
            <input type="password" required className="w-full border rounded-xl px-4 py-2"
              value={form.password_confirmation} onChange={(e) => set('password_confirmation', e.target.value)} />
          </div>
          <div>
            <div className="bg-[#fff8ea] border border-[#f3deb8] rounded-xl p-3 mb-1">
              <p className="text-xs text-[#7a4a1f]">
                <span className="font-semibold">Hai un codice di invito?</span> Inseriscilo qui sotto:
                chi ti ha invitato riceve un credito sul tuo primo ordine completato.
                Il programma è gratuito e senza obblighi. <Link to="/diventa-closer" className="underline">Scopri come funziona →</Link>
              </p>
            </div>
            <label className="block text-sm mb-1">
              Codice Amico <span className="text-gray-400 text-xs">(Opzionale)</span>
            </label>
            <input type="text" className="w-full border rounded-xl px-4 py-2" placeholder="Se sei stato invitato inseriscilo qui"
              value={form.codice_amico} onChange={(e) => set('codice_amico', e.target.value.toUpperCase())} />
            <p className="text-xs text-gray-500 mt-1">Il codice amico premia chi ti ha invitato su Mangitalia.</p>
          </div>

          <button type="button" className="text-sm text-[#c78244] underline"
            onClick={() => setShowFiscal(!showFiscal)}>
            {showFiscal ? 'Nascondi dati fiscali' : 'Aggiungi dati fiscali (opzionale / fattura)'}
          </button>

          {showFiscal && (
            <div className="space-y-3 border border-[#f3deb8] rounded-xl p-3 bg-[#fff8ea]/50">
              <select className="w-full border rounded-xl px-4 py-2 text-sm" value={form.tipo_cliente}
                onChange={(e) => set('tipo_cliente', e.target.value)}>
                <option value="privato">Privato</option>
                <option value="azienda">Azienda (B2B)</option>
              </select>
              {form.tipo_cliente === 'azienda' && (
                <input className="w-full border rounded-xl px-4 py-2 text-sm" placeholder="Ragione sociale"
                  value={form.ragione_sociale} onChange={(e) => set('ragione_sociale', e.target.value)} />
              )}
              <input className="w-full border rounded-xl px-4 py-2 text-sm" placeholder="Codice fiscale"
                value={form.codice_fiscale} onChange={(e) => set('codice_fiscale', e.target.value.toUpperCase())} />
              <input className="w-full border rounded-xl px-4 py-2 text-sm" placeholder="Partita IVA"
                value={form.partita_iva} onChange={(e) => set('partita_iva', e.target.value)} />
              <input className="w-full border rounded-xl px-4 py-2 text-sm" placeholder="Codice destinatario SDI (7 caratteri)"
                maxLength={7} value={form.codice_destinatario} onChange={(e) => set('codice_destinatario', e.target.value)} />
              <input type="email" className="w-full border rounded-xl px-4 py-2 text-sm" placeholder="PEC"
                value={form.pec} onChange={(e) => set('pec', e.target.value)} />
              <label className="flex items-center gap-2 text-sm">
                <input type="checkbox" checked={form.richiede_fattura}
                  onChange={(e) => set('richiede_fattura', e.target.checked)} />
                Richiedo fattura elettronica quando disponibile
              </label>
            </div>
          )}

          <label className="flex items-start gap-2 text-sm text-gray-600 pt-1">
            <input type="checkbox" className="mt-1" checked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.target.checked)} />
            <span>
              Accetto i{' '}
              <Link to="/termini" className="text-[#c78244] underline" target="_blank">Termini</Link>
              {' '}e la{' '}
              <Link to="/privacy" className="text-[#c78244] underline" target="_blank">Privacy Policy</Link>
            </span>
          </label>
          <button type="submit" disabled={loading || !acceptTerms}
            className="w-full bg-[#c78244] text-white py-3 rounded-xl font-semibold mt-2 disabled:opacity-50">
            {loading ? 'Registrazione…' : 'Registrati'}
          </button>
        </form>
        <p className="text-center text-sm mt-4">
          Hai già un account? <Link to="/area-riservata/login" className="text-[#c78244] underline">Accedi</Link>
        </p>
      </div>
    </div>
  );
}
